import styled from 'styled-components';
import { alpha } from '@material-ui/core';

export const ProductBoard = styled.div`
  display: flex;
  margin: 0;
  position: relative;
  overflow-x: auto;
  &.swimlane {
    overflow: visible;
  }
  &:not(.swimlane) {
    overflow-y: hidden;
    overflow-x: auto;
  }

  .column {
    display: flex;
    flex-direction: column;
    margin: 0;
    background: unset;
    border-radius: 4px 4px 0 0;
    &:not(.actions) {
      flex: 1;
      min-width: 300px;
    }
    .column-header {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      white-space: nowrap;
      background-color: #fff;
      border-bottom: solid 1px #ddd;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 1px -1px,
        rgba(0, 0, 0, 0.14) 0px 0px 1px 0px,
        rgba(0, 0, 0, 0.12) 0px -2px 3px 0px;
      .buttons {
        display: flex;
        justify-content: flex-end;
        flex: 1;
      }
      .column-header-link {
        margin-left: 6px;
        color: #000;
      }
      &.expand-collapse {
        padding: 12px 0 12px 30px;
      }
    }
  }

  .column.actions {
    .card-container {
      background: #fff;
      margin-left: 20px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .btn-expand,
    .btn-collapse {
      color: #fff;
      .MuiSvgIcon-root {
        font-size: 1em;
      }
    }
    .btn-expand {
      background-color: #29cc97;
    }
    .btn-collapse {
      background-color: #fec400;
    }
  }

  .sub-column-container {
    /* overflow: hidden; */
  }
  .sub-column {
    /* flex: 50%; */
    height: 50%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    /* overflow: hidden; */
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
      border-radius: 4px 4px 0 0;
    }
  }
  .card-container {
    flex: 1;
    /* height: 50%; */
    /* display: flex; */
    flex-direction: column;
    padding: 10px;
    /* space between rows */
    margin-bottom: 15px;
    background-image: linear-gradient(
      to right,
      ${props => props.theme.palette.primary.light} 90%,
      #c0e5ff 105%
    );
    overflow-y: auto;
  }

  /* space between header */
  &:first-child .card-container {
    margin-top: 15px;
  }

  .column:not(.actions):not(:last-child) .card-container {
    border-radius: 0;
  }
  /* last column */
  .column:last-child .card-container {
    margin-right: 20px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &:not(.swimlane) {
    flex: 1;
  }
  &.swimlane {
    &.stretch,
    &:last-child {
      flex: 1;
    }
    &.hidden {
      flex: unset;
      display: none;
    }
  }

  .task-card {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    min-height: min-content;
    transition: border 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
    &.selected {
      border: 5px solid ${props => alpha(props.theme.palette.primary.main, 0.8)};
      &:not(.collapsed) .title-text {
        &:hover,
        &:focus {
          background-color: rgba(0, 0, 0, 0.08);
        }
      }
    }

    .MuiCardContent-root {
      padding: 16px;
    }

    &.collapsed {
      .content {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        & > :not(:last-child) {
          margin-right: 10px;
        }
      }
      .entity-id {
        white-space: nowrap;
      }
      .title-text {
        overflow: hidden;
        p {
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .card-title {
      display: flex;
      margin-bottom: 6px;
      .accessory {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .entity-id {
      font-weight: bold;
    }
    .title-text {
      outline: none;
      border-radius: 4px;
      transition: background-color 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    &:hover .view-buttons {
      height: auto;
      opacity: 1;
    }
    &:not(:hover) .view-buttons {
      margin: 0;
    }
    .view-buttons {
      display: flex;
      transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
      opacity: 0;
      height: 0;
      max-height: 100px;
      overflow: hidden;
      .view-detail {
        margin-right: 6px;
      }
    }
    .title-actions {
      display: flex;
      margin-top: 10px;
      justify-content: flex-end;
    }
    .info {
      display: flex;
      border-top: solid 1px #e4e4e4;
      padding: 12px 16px;
      align-items: center;
      .assigned {
        flex: 1;
        display: flex;
        align-items: center;
        .icon-wrapper {
          display: flex;
          margin-right: 10px;
          height: 30px;
          width: 30px;
          border-radius: 15px;
          align-items: center;
          justify-content: center;
          background: #eee;
          overflow: hidden;
        }
      }
      .due-date {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .task-card-with-subtask {
    overflow-y: auto;
    background-color: #e6e6e6;
    margin-bottom: 10px;
    padding: 10px 10px 0px 10px;
    .title {
      margin-bottom: 10px;
    }
  }
`;

export const ConnectorContainer = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
`;
